// src/crm/conversations/useConversation.ts
import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api'
import type { Conversation, Message } from '../../lib/types'

export type ConversationData = {
  conversation: Conversation
  messages: Message[]
}

export function useConversation(creatorId: string | null) {
  return useQuery<ConversationData>({
    queryKey: ['conversation', creatorId],
    queryFn: () =>
      api.get<ConversationData>(`/api/conversations?creatorId=${creatorId ?? ''}`),
    enabled: creatorId !== null,
  })
}
